import { selectProductTypes } from '@/redux/productTypes/getters/selectProductTypes';
import { StoreState } from '@/redux/types';
import { getUserDrafts } from '@/redux/userDrafts/getters/getUserDrafts';

export function getDraftCount(state: StoreState) {
  const productTypes = selectProductTypes(state);
  const availableDrafts = getUserDrafts(state).filter(
    (draft) => !draft.isDeleted && productTypes[draft.userDraft.productTypeId]
  );
  return availableDrafts.length;
}
